module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/solution-03-2686c3f951281efdb03da83c5a888538.jpg";